import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserDetail } from "../redux/Authentication/auth.action";
import { formatDateandTime } from "../services/utils";
import { IMAGE_PROXY_URL } from "../services/Api";

export default function TopNavBar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const store = useSelector((state) => state);
  const userData = store?.AuthManager?.userDetail;
  const profileImage = store?.AuthManager?.userDetail?.userdetail?.image;
  const companyData = store?.AuthManager?.userDetail?.userdetail?.company?.name;

  useEffect(() => {
    dispatch(getUserDetail());
  }, []);

  useEffect(() => {
    if (profileImage) {
      setImage(`${IMAGE_PROXY_URL}${profileImage}`);
    }
  }, [profileImage]);

  const handleLogo = () => {
    navigate("/dashboard");
  };

  const handleProfile = () => {
    if (userData?.userdetail?.profile_type === "individual") {
      navigate("/Indv-basic-information");
    } else if (companyData) {
      navigate("/org-basic-information");
    } else {
      navigate("/profile");
    }
  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("token");
    navigate("/signIn");
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };
  return (
    <header className="header">
      <div className="header__left" onClick={handleLogo}>
        <img
          className="mx-auto"
          src="/images/logos/logo-dark.svg"
          alt="Docur Logo"
        />
        <p className="fz12 mb-0 header__subtitle">
          TAG LINE FOR DOCUR WILL BE HERE
        </p>
      </div>

      <div className="header__right">
        <div className="user-info">
          <div className="dropdown">
            <button
              className="border-0 dropdown-toggle user-info__dp"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {image ? (
                <div className="bg-white user-info__dp-inner">
                  <img className="bdrs12 user-image" src={image} />
                </div>
              ) : (
                <div className="bg-white user-info__dp-inner">
                  <span className="bdrs12 fw700 fz34 text-white initials">
                    U
                  </span>
                </div>
              )}
              <b className="bg-white arrow">
                <img
                  src="/images/icons/icon-dropdown-line-arrow.svg"
                  alt="dropdown-line-arrow"
                />
              </b>
            </button>

            <ul className="border-0 dropdown-menu">
              <li>
                <a className="fz12 dropdown-item" onClick={handleProfile}>
                  Profile
                </a>
              </li>
              {/* <li>
                <a className="fz12 dropdown-item" href="#">
                  Another action
                </a>
              </li>
              <li>
                <a className="fz12 dropdown-item" href="#">
                  Something else here
                </a>
              </li> */}
            </ul>
          </div>

          <div className="user-info__name">
            <h6 className="mb-1 fz16 fw500 primaryText">
              {userData?.userdetail?.name ? userData?.userdetail?.name : "User"}
              !
            </h6>
            <p className="mb-0 fz12 grayText">
              <img src="/images/icons/icon-clock-line.svg" alt="clock-line" />
              <span>
                {userData?.userdetail?.created_at
                  ? formatDateandTime(userData?.userdetail?.created_at)
                  : "NA"}
              </span>
            </p>
          </div>
        </div>

        <div className="form-group form-group--search">
          <div className="bdrs12 fab fab--search">
            <img
              src="/images/icons/icon-search-pastel-green.svg"
              alt="Search"
            />
          </div>

          <input
            type="text"
            className="border-0 bdrs12 fz14 form-control"
            placeholder="Search your document here..."
          />
          <ul className="m-0 lh-1 list-inline icons">
            <li>
              <a href="#" className="">
                <span className="dot"></span>
                <img
                  src="/images/icons/icon-bell-header.svg"
                  alt="bell-header"
                />
              </a>
            </li>
            <li>
              <a
                className=""
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                <img src="/images/icons/icon-logout.svg" alt="logout" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      {showLogoutModal && (
        <>
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              zIndex: 1040,
            }}
            onClick={cancelLogout}
          ></div>

          <div
            className="bdrs12 bg-white"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1050,
              padding: "30px",
              width: "100%",
              maxWidth: "360px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
            }}
          >
            <h6 className="fz16 fw600 primaryText mb-3 text-center">
              Confirm Logout
            </h6>
            
            <p className="fz12 grayText mb-4 text-center">
              Are you sure you want to logout?
            </p>

            <div className="d-flex gap-2">
              <button
                type="button"
                className="fz12 fw600 w-100 text-uppercase btn btn-solid"
                onClick={cancelLogout}
                style={{ background: "#f0f0f0", color: "#333", border: "none" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="fz12 fw600 w-100 text-uppercase btn btn-solid btn-solid--dark"
                onClick={confirmLogout}
              >
                Yes
              </button>
            </div>
          </div>
        </>
      )}
    </header>
  );
}
